import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { TealiumService } from 'src/app/services/tealium.service';


@Component({
    selector: 'app-opel-drop-down',
    templateUrl: './opel-drop-down.component.html',
    styleUrls: ['./opel-drop-down.component.less'],
    standalone: false
})
export class OpelDropDownComponent implements OnInit {

  @Input() vehicleInfo: {
    ID: number,
    NAME: string,
    OEM_ID: number
  }[] = [];
  dropDownForm!: FormGroup;
  firstDorpDownValue: {
    ID: number,
    NAME: string,
    DESCRIPTION: string,
    PARENT_ID: number,
    VEHICLE_MODEL_TYPE_ID: number
  }[] = [];
  secondDropDownValue: {
    ID: number,
    NAME: string,
    DESCRIPTION: string,
    PARENT_ID: number,
    VEHICLE_MODEL_TYPE_ID: number
  }[] = [];
  package: [] = [];
  packageInfo: {
    ID: number,
    NAME: string,
    DESCRIPTION: string,
    SIZE: string,
    VERSION: string,
    IMAGE_NAME: string,
    UPLOAD_DATE: string
  }[] = [];
  submitted = false;
  selectedLocale!: boolean;

  brandDropDownToggle: boolean = false;
  modelDropDownToggle: boolean = false;
  naviDropDownToggle: boolean = false;

  formDataDropDown = {
    car_model: '',
    nav_system: ''
  }

  constructor(
    private fb: FormBuilder,
    private dataService: DataService,
    private translate: TranslateService,
        private tealiumService: TealiumService
  ) {
    this.checkSelectedLocale();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.checkSelectedLocale();
    });
  }

  ngOnInit(): void {
    this.dropDownForm = this.fb.group({
      firstDropDown: [null, [Validators.required]],
      firstDropDownVal: [null, [Validators.required]],
      secondDropDown: [null, [Validators.required]],
      secondDropDownVal: [null, [Validators.required]],
    });
    for (const val of this.vehicleInfo) {
      this.firstDorpDownValue = this.dataService.getFirstDropDownValue(val.ID);
      if (this.firstDorpDownValue.length > 0) {
        break;
      }
    }
  }

  ngAfterViewInit() {
    this.changeValueIntoInnerHtml('index.firstDropDown', 1);
    this.changeValueIntoInnerHtml('index.secondDropDown', 2);
  }

  changeValueIntoInnerHtml(key: string, numberInput: number) {
    const input: any = document.querySelectorAll("input")[numberInput];
    if (input) {
      this.translate.get(key).subscribe((result: any) => {
        input.textContent = result;
        setTimeout(() => {
          input.value = input.textContent;
        }, 500);
      });
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        input.textContent = this.translate.instant(key);
        setTimeout(() => {
          this.dropDownForm.reset();
          input.value = input.textContent;
        }, 500);
      });
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.dropDownForm.controls;
  }

  openBrandDropDown() {
    this.brandDropDownToggle = !this.brandDropDownToggle;
  }

  openModelDropDown() {
    this.modelDropDownToggle = !this.modelDropDownToggle;
    this.dropDownForm.controls['firstDropDown'].valueChanges.subscribe(value => {
      if (value !== this.dropDownForm.value['firstDropDown']) {
        this.secondDropDownValue = [];
        this.dropDownForm.patchValue({
          secondDropDown: null,
          secondDropDownVal: null,
        });
      }
    });
  }

  closeDropDown() {
    this.brandDropDownToggle = false;
    this.modelDropDownToggle = false;
    this.naviDropDownToggle = false;
  }

  fetchCarModelData(id: number | null, name: string | null) {
    this.dropDownForm.patchValue({
      firstDropDown: id,
      firstDropDownVal: name
    });
    if (this.dropDownForm.value.firstDropDown) {
      this.secondDropDownValue = this.dataService.getOtherDropDownValues(Number(this.dropDownForm.value.firstDropDown));
    }
    this.brandDropDownToggle = false;
  }

  fetchCarNaviData(id: number | null, name: string | null) {
    this.dropDownForm.patchValue({
      secondDropDown: id,
      secondDropDownVal: name
    });
    this.modelDropDownToggle = false;
  }

  fetchPackageData() {
    this.submitted = true;
    this.package = [];
    if (this.dropDownForm.invalid) {
      return;
    }
    const packageId: {
      PACKAGE_ID: number,
      VEHICLE_MODEL_ID: number
    }[] = this.dataService.getPackageId(this.getPackageDataDropDownValue());
    let result: any = [];
    for (const val of packageId) {
      result.push(this.dataService.getPackageData(val.PACKAGE_ID));
    }
    this.package = result;
    this.submitted = false;
    this.formDataDropDown = {
      car_model: this.dropDownForm.value.firstDropDownVal,
      nav_system: this.dropDownForm.value.secondDropDownVal
    }
    this.tealiumService.trackEvent({
      event_name: 'navshop_click',
      click_text: 'search_for_updates_button_click',
      car_model: this.dropDownForm.value.firstDropDownVal,
      nav_system: this.dropDownForm.value.secondDropDownVal
    });
  }

  getPackageDataDropDownValue() {
    const oemName = this.dataService.getOemName();
    if (oemName === 'stellantis') {
      return this.dropDownForm.value.thirdDropDown
    } else if (oemName === 'iveco') {
      return this.dropDownForm.value.firstDropDown
    } else {
      return this.dropDownForm.value.secondDropDown
    }
  }

  checkSelectedLocale() {
    if (this.translate.currentLang.includes('cs_CZ') ||
      this.translate.currentLang.includes('fr_FR') ||
      this.translate.currentLang.includes('fr_CA') ||
      this.translate.currentLang.includes('nb_NO') ||
      this.translate.currentLang.includes('pl_PL') ||
      this.translate.currentLang.includes('es_ES')) {
      this.selectedLocale = true;
    } else {
      this.selectedLocale = false;
    }
  }
}
